import StaffLoginForm from "@/components/Auth/StaffLoginForm";

export default function AuctionLoginPage() {
    return (
        <StaffLoginForm
            title="Auction Staff Login"
            subtitle="Sign in to the Auction management portal"
            backgroundImage="/images/assets/dealership_auction_futuristic_1.png"
        />
    );
}
